import { Observable } from 'rxjs';

import { Guid } from '@fitscovery/common/types';
import { PartnerBooking } from '../models';

export enum BookingStatus {
  Pending,
  Confirm,
  Reject,
  Schedule
}

export interface BookingService {
  getPartnerBooking(partnerId: Guid): Observable<PartnerBooking>;
  getUpcomingBookings(partnerId: Guid): Observable<any>;
  updatePartnerBooking(bookingDetails: PartnerBooking): Observable<PartnerBooking>;
  updateMemberBooking(updatedBooking: any): Observable<any>;
}
